import { componentIdSchema } from '@customTypes/cloudmix/sessions/components/base'
import {
  componentPanelTypeSchema,
  componentTypeSchema,
} from '@features/projects/components/manage/routing'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

export const paramSchema = z.object({
  ct: componentTypeSchema.optional(),
  id: componentIdSchema.optional(),
  cp: componentPanelTypeSchema.optional(),
  i: z.string().optional(),
})

export const Route = createFileRoute(
  '/_auth/o/$orgId/projects/$projectId/manage'
)({
  loader: () => ({
    crumb: 'Manage',
  }),
  validateSearch: paramSchema,
})
